var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.InfoContainer,{attrs:{"title":"Installer"}},[_c('div',{staticClass:"tw-mt-3 tw-w-60 tw-h-35"},[_c(_setup.FormField,{attrs:{"label":"Installer","options":_setup.partners,"null-option":"Select installer","type":"select","value":_vm.value},on:{"input":_setup.onInstallerChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }